module.exports = __webpack_public_path__ + "img/Illustration-point.3776ec77.png";